<template>
    <div style="padding-bottom: 15px;">
        <p class="little-label">7E个人版升级为7C机构版</p>
        <div class="step_item">
            验证未到期账号
        </div>
        <div class="step_content" v-show='showTips != "success"'>
            账号<input type="text" v-model='user' />&nbsp;请输入密码进行验证<input type="password" v-model='usernumber'>
            <NormalButton style='height:26px;width:55px;' :disabled='$route.name == "Preview" ?  true : false'
                class="blue_btn" @click='send'>去验证</NormalButton>
            <a class="forget_pwd" target="_blank" :href="forgetPwdUrl">找回账号密码</a>
        </div>
        <div class="line-dot">
            <div class="tips" v-show='showTips == "success"'>
                <h5><i class="success-icon"></i>账号 {{user}} 验证成功！<b @click='back' class='back'>继续对其它账号升级套餐</b></h5>
                <p>本次升级套餐，只收取自今日起至账号{{user}}到期日期间相应费用（不足一个月，按一个月计），升级后授权到期日同此账号到期日：<span
                        class='date'>{{limitDate}}</span>。</p>
            </div>
            <div class="tips" v-show='showTips == "fail"'>
                <h5><i class="fail-icon"></i>验证失败</h5>
                <p>{{errMsg}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'upgrade',
        inject: ['changeMainPrice','addValidCross'],
        data: ()=>({
            showTips: '',
            user: '',
            usernumber: '',
            limitDate: '',
            errMsg: ''
        }),
        methods: {
            send () {},
            back () {
                this.addValidCross(false)
                this.showTips = ''
            },
        },
        computed: {
            forgetPwdUrl () {
                var url = ''
                if (this.$route.params.id == 76) {
                    url = 'https://www.wenhua.com.cn/home/whsforgot?client=wh7'
                } else if (this.$route.params.id == 1) {
                    url = 'https://www.wenhua.com.cn/home/whsforgot?client=wh8'
                } else if (this.$route.params.id == 124) {
                    url = 'https://www.wenhua.com.cn/home/whsforgot?client=wh9'
                } else if (this.$route.params.id == 125 || this.$route.params.id == 138) {
                    url = 'https://wh10.wenhua.com.cn/AutoRegister'
                }
                return url
            }
        }
    }
</script>

<style scoped>
    .little-label {
        font-size: 12px;
        color: rgb(111, 111, 113);
        clear: both;
        padding: 5px 0 4px;
        margin: 0;
    }

    .line-dot {
        border-bottom: 1px dashed rgb(136, 137, 138);
        clear: both;
        padding-top: 10px;
        margin-bottom: 10px;
    }

    .choose_item {
        float: left;
    }

    .step_item {
        font-size: 14px;
        color: rgb(6, 96, 172);
    }

    .step_content {
        color: rgb(111, 111, 113);
        font-size: 14px;
        margin-top: 10px;
    }

    .step_content input {
        width: 90px;
        background: white;
        border: 1px solid rgb(192, 192, 192);
        height: 25px;
        line-height: 22px;
        border-radius: 2px;
        margin: 0 4px;
        outline: none;
        padding-left: 10px;
    }

    .forget_pwd {
        color: rgb(6, 96, 172);
        font-size: 12px;
        margin-left: 5px;
        position: relative;
        top: 5px;
    }

    .blue_btn {
        background: rgb(6, 96, 172);
        color: white;
        font-size: 12px;
        border: 0;
        border-radius: 3px;
        padding: 5px 10px;
        outline: 0;
    }

    .tips {
        background: rgb(255, 245, 233);
        color: rgb(129, 91, 36);
        padding: 10px;
    }

    .tips h5 {
        padding: 0;
        margin: 0;
        margin-bottom: 5px;
        font-size: 13px;
    }

    .tips p {
        margin: 0;
    }

    .tips p .date {
        color: rgb(253, 98, 43);
        font-size: 14px;
    }

    .tips h5.success {
        padding-left: 20px;
    }

    .success-icon {
        width: 20px;
        height: 11px;
        display: inline-block;
        background: url(../assets/image/duicuo.png) no-repeat left center;
    }

    .tips h5 .back {
        padding-left: 20px;
        float: right;
        background: url(../assets/image/fanhui.png) no-repeat left center;
        color: rgb(60, 141, 237);
        text-decoration: underline;
        border: 0;
        cursor: pointer;
        outline: none;
        font-weight: normal;
    }

    .fail-icon {
        width: 20px;
        height: 11px;
        display: inline-block;
        background: url(../assets/image/duicuo.png) no-repeat -25px center;
    }
</style>